import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";

interface UploadCsvPartSourceData {
  file: File;
}

export const useUploadCsvPartSourceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ file }: UploadCsvPartSourceData) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("category", "csv");

      const res = await handleClientMethod(
        getClient().POST("/part-sources", {
          body: formData as any, // hack...
        }),
      );
      return res;
    },
    onSuccess: () => {
      // Invalidate part-source list queries
      queryClient.invalidateQueries({ queryKey: ["part-sources", "list"] });
      // Invalidate parts list queries since uploading a CSV affects parts data
      queryClient.invalidateQueries({ queryKey: ["parts", "list"] });
    },
  });
};
